import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SignatureGroup } from '../models/signature-group';
import { FilterSignature } from '../models/filters/filter-signature';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/signatures';

  findAllPageableSignature(filterSignature: FilterSignature, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterSignature);
  }
  
  findSignatureGroupById(id: number): Observable<SignatureGroup> {
    return this.http.get<SignatureGroup>(`${this.url}/${id}`);
  }

  createSignatureGroup(signatureGroup: SignatureGroup): Observable<SignatureGroup>{
    return this.http.post<SignatureGroup>(this.url, signatureGroup);
  }

  updateSignatureGroup(signatureGroup: SignatureGroup): Observable<SignatureGroup>{
    return this.http.put<SignatureGroup>(`${this.url}/${signatureGroup.id}`, signatureGroup);
  }
}
